import { Component, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

/**
 *  E-MAIL ELKAPÓ (Szervíz) – a Dokumentumtárból leválasztva, saját menüpontként.
 *
 *  Minden ügyfélnek van egy címe (<adószám>@<domain>): az oda küldött számlák mellékletei a
 *  Dokumentumtárba kerülnek. Itt látszik az ügyfél címe, a hozzá beérkezett levelek, és itt
 *  állítható a központi elosztó (a teljes installációra, egyszer – lásd backend: naplo.js /email).
 */
@Component({
  selector: 'app-naplo-email-elkapo',
  templateUrl: './email-elkapo.component.html',
  styleUrls: ['../naplo-shared.scss', './email-elkapo.component.scss'],
})
export class EmailElkapoComponent implements OnInit {
  emailek: any[] = [];
  beall: any = null;
  cim = '';
  regFut = false;
  betoltes = false;

  constructor(private naplo: NaploService, private toast: ToastController) {}
  get aktiv() { return this.naplo.aktiv; }
  get domain() { return (this.beall && this.beall.email_domain) || 'naplo.cronomit.org'; }

  async ngOnInit() {
    await this.naplo.init();
    await this.betolt();
  }

  async betolt() {
    this.betoltes = true;
    const u = this.aktiv.ugyfelId;
    await Promise.all([
      u ? this.naplo.get('/email?ugyfelId=' + u).then((r: any) => (this.emailek = r || [])).catch(() => (this.emailek = [])) : null,
      u ? this.naplo.get('/email/cim/' + u).then((r: any) => (this.cim = r?.cim || '')).catch(() => (this.cim = '')) : null,
      this.naplo.get('/email/beallitas').then((r: any) => (this.beall = r || {})).catch(() => (this.beall = {})),
    ]);
    this.betoltes = false;
  }

  async masol() {
    const c = this.cim || '';
    if (!c) return;
    try { await navigator.clipboard.writeText(c); this.uzen('A cím a vágólapra került.'); } catch { this.uzen(c); }
  }

  async ment() {
    try { await this.naplo.put('/email/beallitas', this.beall || {}); await this.betolt(); this.uzen('Beállítások mentve.'); }
    catch (e: any) { this.uzen(e?.error?.error || 'A mentés nem sikerült.', true); }
  }

  async regisztracio() {
    this.regFut = true;
    try { const r: any = await this.naplo.post('/email/regisztracio', {}); this.uzen(`Regisztrálva: ${r.adoszamok} adószám a központban.`); }
    catch (e: any) { this.uzen(e?.error?.error || 'A regisztráció nem sikerült.', true); }
    finally { this.regFut = false; }
  }

  private async uzen(message: string, hiba = false) {
    (await this.toast.create({ message, duration: hiba ? 4000 : 2200, color: hiba ? 'danger' : 'success', position: 'top' })).present();
  }
}
